import { Component, OnInit, Inject } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA, } from '@angular/material/dialog';
import { ConfirmationDialog } from '../confirmation-dialog/confirmation-dialog.component';
import { PostulacionesService } from '../../services/postulaciones/postulaciones.service';
import Swal from 'sweetalert2';
import { AlertDialogComponent } from '../alert-dialog/alert-dialog.component';
import { ConvenioService } from 'src/app/services/convenio/convenio.service';
import { environment } from '../../../environments/environment';
import { DialogTipoRechazoConvenio } from './convenio-rechazar.component';
import { NgForm } from '@angular/forms';
export interface DialogData
{
    rol: string
    mostrarEditar:boolean
    disponiblePago:boolean
    presionaEditar:boolean
    mostrarAprobarButton:boolean
    deshabilitado:boolean
    recarga:any
    regiones : any
    categorias: any
    calcula:any
    totalMaximo: any
    proveedores:any
    idUsuario:any
    cuotas: any
    idCodeudor : any
    montoSolicitado:any
    idConvenio: any
    idPostulacion : any
    nombreUsuario : any
    rutUsuario: any
    idCantidadCuota: any
    montoCuota: any
    fechaIngreso:any
    fechaPrimerPago :any
    idTipoConvenio: any
    idRegion: any
    nombreCodeudorUno: any
    nombreCodeudorDos: any
    rutCodeudorUno: any
    rutCodeudorDos: any
    idProveedor: any
    idProducto: any 
    idCarga:any
    nombreCarga: any
    planes:any
    rutCarga:any 
    numPresupuesto: any
    tieneConvenioAdjunto: any    
    idAfiliado:any
}
    @Component({
    selector: 'dialog-overview-convenio-dialog',
    templateUrl: '../../pages/convenio/convenio-validar.html',
    styleUrls: ['../../pages/convenio/convenio.component.css']
})
export class DialogEditConvenioEjecutivo
{
    rol =localStorage.getItem("rol")
    convenio: any = {
        regiones : this.data.regiones,
        categorias: this.data.categorias,
        totalMaximo: this.data.totalMaximo,
        proveedores:this.data.proveedores,
        cuotas: this.data.cuotas,
        idCodeudor : this.data.idCodeudor,
        montoSolicitado:this.data.montoSolicitado,
        idConvenio: this.data.idConvenio,
        idPostulacion : this.data.idPostulacion,
        nombreUsuario : this.data.nombreUsuario,
        rutUsuario: this.data.rutUsuario,
        idCantidadCuota: this.data.idCantidadCuota,
        montoCuota: this.data.montoCuota,
        fechaIngreso:this.data.fechaIngreso,
        fechaPrimerPago :this.data.fechaPrimerPago,
        idTipoConvenio: this.data.idTipoConvenio,
        idRegion: this.data.idRegion,
        nombreCodeudorUno: this.data.nombreCodeudorUno,
        nombreCodeudorDos: this.data.nombreCodeudorDos,
        rutCodeudorUno: this.data.rutCodeudorUno,
        rutCodeudorDos: this.data.rutCodeudorDos,
        idProveedor: this.data.idProveedor,
        idCarga: this.data.idCarga,
        nombreCarga: this.data.nombreCarga,
        rutCarga: this.data.rutCarga,
        idProducto: this.data.idProducto,
        numPresupuesto: this.data.numPresupuesto,
        idAfiliado: this.data.idAfiliado,
        tieneConvenioAdjunto: this.data.tieneConvenioAdjunto,        
        calcula: 0,
        archivo: { bytes: null, tipo: null ,size:null},
        archivoTest: null,
        planes:[]}
        cantidadArchivos: any = 2
    constructor( public dialogRef: MatDialogRef<DialogEditConvenioEjecutivo>,
        private convenioService: ConvenioService,
        @Inject(MAT_DIALOG_DATA) public data: DialogData, private dialog: MatDialog )
                 {
                    this.data= data;
                   
                  }

    ngOnInit(): void
         { this.loadData() }
    loadData()
        {
           this.convenio.idPostulacion = this.data.idPostulacion 
            this.convenio.idConvenio= this.data.idConvenio
            this.data.calcula = 0
            this.data.presionaEditar = false
            this.data.mostrarAprobarButton=true
            //this.data.mostrarEditar= true
            this.data.presionaEditar=false
            this.data.deshabilitado = true
            this.data.recarga = false
            this.data.rol = localStorage.getItem("rol")
            this.data.idUsuario = localStorage.getItem("idUsuario")
        }
    onCancelarClick(): void { this.dialogRef.close() }

    onRechazarClick():void {
        let vm = this
        const dialogRef = this.dialog.open(ConfirmationDialog,
            {
                data: { message: '¿Esta seguro de rechazar ser codeudor?', buttonText: { ok: 'Si', cancel: 'No' } }
            })
            dialogRef.afterClosed().subscribe((confirmed: boolean) =>
            {
                if (confirmed){
                    Swal.fire({
                        allowOutsideClick:false,
                        icon:'info',
                        text:'Cargando...'
                      });
                      Swal.showLoading();
                      console.log("rechazar codeudor");
                    this.convenioService.rechazarSerCodeudor(this.convenio,localStorage.getItem("idUsuario"),false).then
                    (
                        () =>
                        {
                            let vm=this
                         
                            vm.openAlertDialog('Se ha rechazado ser codeudor.', 'btn-success')
                            
                            Swal.close();
                        }
                    )
                    .catch((err) => {
                        vm.openAlertDialog('Ocurrió un al rechazar a ser codeudor.', 'btn-danger')
                    });
                      vm.dialogRef.close()
                     Swal.close();
                }
            })
        }
    
        
    onAceptarClick():void{
        let vm = this

        const dialogRef = this.dialog.open(ConfirmationDialog,
        {
            data: { message: '¿Esta seguro de aceptar ser codeudor?', buttonText: { ok: 'Si', cancel: 'No' } }
        })
        dialogRef.afterClosed().subscribe((confirmed: boolean) =>
        {
            if (confirmed){
                Swal.fire({
                    allowOutsideClick:false,
                    icon:'info',
                    text:'Cargando...'
                  });
                  Swal.showLoading();
 
            let sizeArchivos=0;
            

            for (let i = 1; i < this.cantidadArchivos; i++) {
                sizeArchivos += this.convenio.archivos[i].size;
                if (sizeArchivos > 25000000) {
                    this.openAlertDialog('Los archivos no deben sobrepasar 25mb en total', 'btn-dark')
                    Swal.close();
                 
                    return;
                }
                if (this.convenio.archivos[i].extension != "application/pdf" && this.convenio.archivos[i].extension != "image/jpeg" &&
                    this.convenio.archivos[i].extension != "image/jpg" && this.convenio.archivos[i].extension != "image/png") {
                    this.openAlertDialog('El archivo ' + (i + 1) + ' debe ser de tipo no modificable (PDF, PNG, JPEG, JPG)', 'btn-dark')
                    this.convenio = false
                    Swal.close();
                    return false
                }
            }


            this.convenio.idConvenio = this.data.idConvenio;
 

                  this.convenioService.aprobarSerCodeudor(
                      this.convenio,
                    localStorage.getItem("idUsuario"),true).then
                  (
                      () =>
                      {
                          let vm=this
                       
                          vm.openAlertDialog('Se ha aprobado ser codeudor exitosamente.', 'btn-success')
                          
                          Swal.close();
                      }
                  )
                  .catch((err) => {
                      vm.openAlertDialog('Ocurrió un al aprobar ser codeudor.', 'btn-success')
                  });
                    vm.dialogRef.close()
                   Swal.close();
              }
                  vm.dialogRef.close()
                 Swal.close();
            }
         )
    }

    seleccionaArchivo(event: any)
    {
      let numero= 0;
        if(event.target.files.length > 0)
        {
            console.log(event.target.files[0].type)

            let vm = this
            let reader = new FileReader()
            this.convenio.archivo[numero] = { url: "", archivo: reader.result, extension: event.target.files[0].type, size:event.target.files[0].size }
            reader.readAsDataURL(event.target.files[0])

            reader.onload = function() {
                vm.convenio.archivo[numero] = { url: "", archivo: reader.result, extension: event.target.files[0].type, size:event.target.files[0].size }

               // console.log(vm.prestamo.archivo)
            }
        }
    }

    openAlertDialog(mensaje: string, clase: string)
    {
        this.dialog.open(AlertDialogComponent, {
            data: { message: mensaje, clase: clase, buttonText: { cancel: 'Listo!' }, }
        })
    }

    onDescargarArchivosClick(postulacionId: any)
    {
        let vm = this
        console.log("traeArchivo",postulacionId);
        vm.convenioService.traeArchivos(postulacionId).then
        (
            (archivos: any) =>
            {                
                archivos.forEach( archivo => {
                    var fileURL=`${environment.urlBlob}/${archivo.url}`    
                    window.open(fileURL,'_blank')                     
                })  
                
            }
        )
        .catch
        (
            error =>
            {
                console.log(error)
                vm.openAlertDialog('Ha ocurrido un error para visualizar el archivo.', 'btn-danger')
            }
        )
    }

    onDescargarConvenioArchivosClick(postulacionId: any)
    {
        let vm = this
        console.log("traeArchivo",postulacionId);
        vm.convenioService.traeArchivosConvenio(postulacionId).then
        (
            (archivos: any) =>
            {                
                archivos.forEach( archivo => {
                    var fileURL=`${environment.urlBlob}/${archivo.url}`    
                    window.open(fileURL,'_blank')                     
                })  
                
            }
        )
        .catch
        (
            error =>
            {
                console.log(error)
                vm.openAlertDialog('Ha ocurrido un error para visualizar el archivo.', 'btn-danger')
            }
        )
    }



    onEditarPostulacionClick(): void
    {
        this.data.deshabilitado = false
        this.data.presionaEditar = true
    
    }
    calcularPlanPago(){
        let vm = this
   
        vm.convenioService.calcularPlanPagoConvenio(vm.convenio.montoSolicitado,vm.convenio.idCantidadCuota).
        then(
            (planes : any)=>
              {
                this.data.calcula=this.data.calcula+1;
                this.data.montoCuota = planes[0].montoTotalCuota;
                this.data.fechaPrimerPago = planes[0].fechaPago;
                this.convenio.montoCuota = planes[0].montoTotalCuota;
                this.convenio.montoCuota = planes[0].montoCuota
                this.convenio.fechaPrimerPago = planes[0].fechaPago;
                this.convenio.planes = planes;
               
            }
          )
          .catch ( error =>
            {
                console.log(error)
                Swal.close();
                this.openAlertDialog('No se pudo calcular el plan de pago. Intente nuevamente.', 'btn-danger')
            } )
        }

    
    onAprobarPostulacionClick(idPostulacion: any,idUsuario:any): void
    {
        let vm = this

        const dialogRef = vm.dialog.open(ConfirmationDialog, {
            data: { message: '¿Esta seguro de aprobar el convenio?', buttonText: { ok: 'Si', cancel: 'No' } }
        })
        dialogRef.afterClosed().subscribe((confirmed: boolean) =>
        {
            if (confirmed)
            {

              Swal.fire({
                allowOutsideClick:false,
                icon:'info',
                text:'Cargando...'
              });
              Swal.showLoading();
              
              vm.convenioService.cambiarEstadoPostulacion(idPostulacion, "APROBADA",
              ).then
                (
                    () =>
                    {
                        vm.dialogRef.close()
                        Swal.close();
                        vm.openAlertDialog('La postulación se ha aprobado exitosamente.', 'btn-success')
                        
                    }
                )
                .catch
                (
                    error =>
                    {
                        console.log(error)
                          Swal.close();
                        vm.dialogRef.close()
                        vm.openAlertDialog('Ha ocurrido un error al guardar la postulación', 'btn-danger')
                    }
                ) 
                
            }
        })
    }
    onGuardarClick(form: NgForm){
        let vm = this
       
        if(this.data.calcula==0){
            vm.openAlertDialog('Para modificar el convenio primero debe presionar el botón Calcular.', 'btn-danger')                   
            Swal.close();
            return false
        }

        if(!this.data.numPresupuesto || this.data.numPresupuesto==0){
            vm.openAlertDialog('El número de presupuesto no debe ir vacio o ser igual a 0', 'btn-danger')                   
            Swal.close();
            return false
        }
    
        const dialogRef = this.dialog.open(ConfirmationDialog,
            {
                data: { message: '¿Esta seguro de guardar los cambios al Convenio?', buttonText: { ok: 'Si', cancel: 'No' } }
            })
            dialogRef.afterClosed().subscribe((confirmed: boolean) =>
            {
                if (confirmed){
                    Swal.fire({
                        allowOutsideClick:false,
                        icon:'info',
                        text:'Cargando...'
                      });
                      Swal.showLoading();

                        vm.convenioService.guardarEdicion( vm.convenio, this.data.idUsuario,this.data.numPresupuesto).then(
                            ()=>{
                                       
                                vm.openAlertDialog('Se ha guardado exitosamente el convenio.', 'btn-success')
                                
                                Swal.close();
                                this.dialogRef.close();
                            }
                        ).catch ( error =>
                            {   
                                if(error.status == 304){
                                    this.openAlertDialog('No se puede modificar el prestamo debido a que una o más cuotas del plan ya fueron gestionadas.', 'btn-danger')
                                    Swal.close();
                                }                                
                                if(error.status == 406){
                                    this.openAlertDialog('Los Codeudores deben ser distintos y también diferentes al solicitante.', 'btn-danger')
                                  }
              
                                  if(error.status == 403){
                                    this.openAlertDialog('Debe seleccionar una región.', 'btn-danger')
                
                                  }
                                  if(error.status == 411){
                                    this.openAlertDialog('El monto a solicitar no debe ser mayor a su tope de deuda.', 'btn-danger')
                                }
                                  if(error.status == 417){
                                    this.openAlertDialog('La cantidad de cuotas debe ser mayor a 0.', 'btn-danger')
                  
                                  }
                                  if(error.status == 422){
                                    this.openAlertDialog('Debe seleccionar un tipo de convenio.', 'btn-danger')
                  
                                  }
                                  if(error.status == 424){
                                    this.openAlertDialog('El valor de cuota a pagar debe ser mayor a 0.', 'btn-danger')
                  
                                  }
                                console.log(error)
                                this.convenio.archivo = [];
                                Swal.close();
                                if(error.status == 500){
                                  this.openAlertDialog('No se pudo ingresar el cambio en convenio. Intente nuevamente.', 'btn-danger')
                                }
                              } )
                }
            })
                    
    }
    onRechazarPostulacionClick(idPostulacion: any): void
    {
               
        let vm = this
       
        let dataRechazo: any =
        {
            idPostulacion: idPostulacion,
            tiposRechazo: [],
            tipoRechazo: '',
            email: '',
            nombreCompleto: '',
            nombreProducto: 'CONVENIO'
        }

        this.convenioService.motivoRechazo(5).then
        (
            rechazos => { dataRechazo.tiposRechazo = rechazos
              
              }
        )
        .catch ( error => {console.log(error)
      } )

        const dialogRechazo = this.dialog.open(DialogTipoRechazoConvenio, { width: '50%', 
            data: dataRechazo });

        dialogRechazo.afterClosed().subscribe( () =>
        {
            vm.data.recarga = true
            vm.dialogRef.close()
        })
    }
    openDialogAnular(idPostulacion: any, rut: any)
    {
        const dialogRef = this.dialog.open(ConfirmationDialog,
        {
            data: { message: '¿Esta seguro de anular la solicitud de Convenio?', buttonText: { ok: 'Si', cancel: 'No' } }
        })

        dialogRef.afterClosed().subscribe( (confirmed: boolean) =>
        {
            if (confirmed)
            {

              Swal.fire({
                allowOutsideClick:false,
                icon:'info',
                text:'Cargando...'
              });
              Swal.showLoading();
                let vm = this
            
                this.convenioService.cambiarEstadoPostulacion(idPostulacion, "ANULADA").then
                (
                    () =>
                    {
                        Swal.close();
                        vm.openAlertDialog('La postulación se ha anulado exitosamente.', 'btn-success')
                        vm.dialogRef.close()
                    }
                )
                .catch
                (
                    error =>
                    {
                        Swal.close();
                        vm.openAlertDialog('La postulación no se ha podido anular.', 'btn-danger')
                        vm.dialogRef.close()
                    }
                )

            }
        })
    }
    onGuadaryAprobarClick(form: NgForm){
        let vm = this;

        if(!this.data.numPresupuesto || this.data.numPresupuesto==0){
            vm.openAlertDialog('El número de presupuesto no debe ir vacio o ser igual a 0', 'btn-danger')                   
            Swal.close();
            return false
        }

        vm.convenioService.guardarEdicion( vm.convenio,this.data.idUsuario,this.data.numPresupuesto).then(
            ()=>{
                       
                vm.onAprobarPostulacionClick(this.convenio.idPostulacion,null)
                
                
            }
        ).catch ( error =>
            {
                if(error.status == 406){
                    this.openAlertDialog('Los Codeudores deben ser distintos y también diferentes al solicitante.', 'btn-danger')
                  }

                  if(error.status == 403){
                    this.openAlertDialog('Debe seleccionar una región.', 'btn-danger')

                  }
                  if(error.status == 411){
                    this.openAlertDialog('El monto a solicitar no debe ser mayor a su tope de deuda.', 'btn-danger')
                }
                  if(error.status == 417){
                    this.openAlertDialog('La cantidad de cuotas debe ser mayor a 0.', 'btn-danger')
  
                  }
                  if(error.status == 422){
                    this.openAlertDialog('Debe seleccionar un tipo de convenio.', 'btn-danger')
  
                  }
                  if(error.status == 424){
                    this.openAlertDialog('El valor de cuota a pagar debe ser mayor a 0.', 'btn-danger')
  
                  }
                
                if(error.status == 500){
                  this.openAlertDialog('No se pudo ingresar el cambio en convenio. Intente nuevamente.', 'btn-danger')
                }
                console.log(error)
             //   this.convenio.archivo = [];
                
                 Swal.close();

              } )
    }

    }

